<template @click="dismissMenuIconGuide">
    <div>
        <div
            v-if="isNewContactRecordGuideEnabled"
            :class="[contactPermissionDTO.canDelete && contactPermissionDTO.canEditAllRecords ? 'menu-guide' : 'menu-guide-small']"
        >
            <ds-guide
                :show="displayMenuGuide"
                position="left"
                :body-text="$options.NEW_CONTACT_DROPDOWN_GUIDE"
                confirm-text="Ok, got it"
                has-close
                @confirm="dismissMenuGuide"
                @cancel="dismissMenuGuide"
            />
        </div>
        <div class="controls">
            <ds-dropdown class="dropdown" position="bottom-end" @close="dismissMenuGuide">
                <ds-guide
                    v-if="isNewContactRecordGuideEnabled"
                    :show="displayMenuIconGuide"
                    position="left"
                    :body-text="$options.NEW_CONTACT_DROPDOWN_GUIDE"
                    confirm-text="Ok, got it"
                    has-close
                    @confirm="dismissMenuIconGuide"
                    @cancel="dismissMenuIconGuide"
                />
                <ds-filled-button id="contactInfoHeaderControlsIcon" class="icon-only" @click="dismissMenuIconButtonGuide">
                    <ds-icon data-qa="drop-down" name="more-horizontal" />
                </ds-filled-button>
                <div slot="menu">
                    <ul class="dropdown-menu-list">
                        <li
                            v-if="contactPermissionDTO.canDelete && contactPermissionDTO.canEditAllRecords"
                            class="dropdown-menu-item"
                            data-qa="delete-contact"
                            @click="showConfirmModal"
                        >
                            <ds-icon class="menu-item-icon" name="trash-2" />
                            Delete contact
                        </li>
                        <li
                            class="dropdown-menu-item"
                            @click="contactLayout"
                        >
                            <ds-icon class="menu-item-icon" name="settings" />
                            Customize contact record
                        </li>
                    </ul>
                </div>
            </ds-dropdown>

            <ds-filled-button
                v-if="contactPermissionDTO.canEditAllRecords"
                data-qa="update-contact"
                type="submit"
                @click="saveContactInfoDetails"
            >
                Save
            </ds-filled-button>

            <delete-contact
                ref="confirmModal"
                :contact-id="contactRecordDetails.contactId"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import DeleteContact from './DeleteContact';
import { loadFtu, updateFtuItem } from '@/ftu.utils';
import { FTU_TYPES } from '@/ftu.constants';

export const NEW_CONTACT_DROPDOWN_GUIDE = 'The new contact record is now fully customizable! Click here to try it out.';
export const GUIDE_TIMEOUT_MS = 1000;
export const INITIAL_GUIDE_TIMEOUT_MS = 3000;
export default {

    NEW_CONTACT_DROPDOWN_GUIDE,
    GUIDE_TIMEOUT_MS,
    INITIAL_GUIDE_TIMEOUT_MS,
    components: {
        DeleteContact,
    },

    props: {
        contactRecordDetails: Object,
        isContactInfoChanged: Boolean,
        userId: [String, Number],
        appId: [String, Number],
    },

    data() {
        return {
            buttonActionName: '',
            isTabLoaded: false,
            contactPermissionDTO: {},
            isContactLayoutEnabled: false,
            isNewContactRecordGuideEnabled: false,
            displayMenuIconGuide: false,
            displayMenuGuide: false,
            ftu: {},
        };
    },

    created() {
        this.$root.$on('CONTACTPERMISSIONS', (contactPermissions) => {
            this.contactPermissionDTO = contactPermissions;
        });

        this.load();
    },

    async mounted() {
        this.$root.$on('CUSTOM_DATA_LOADED', (isTabLoaded) => {
            this.isTabLoaded = isTabLoaded;
        });

        this.$root.$on('OPEN_CONFIRM_MODAL', (actionItem) => {
            this.buttonActionName = actionItem;
            this.saveContactRecord();
        });

        this.ftu = await loadFtu(this.appId, this.userId);
        this.timeout(this.showMenuIconGuide(), this.$options.INITIAL_GUIDE_TIMEOUT_MS);
    },

    beforeDestroy() {
        this.$root.$off('OPEN_CONFIRM_MODAL');
        this.$root.$off('CUSTOM_DATA_LOADED');
    },

    methods: {
        saveContactRecord() {
            if (this.isContactInfoChanged) {
                this.updateContactInfo();
            } else {
                this.saveCustomFieldData();
            }
        },

        saveContactInfoDetails() {
            if (this.isContactInfoChanged) {
                this.updateContactInfo();
            }
        },

        saveCustomFieldData() {
            if (this.isTabLoaded) {
                this.$root.$emit('SAVE_CUSTOM_FIELD', this.buttonActionName);
            } else {
                this.pageRedirect(this.buttonActionName);
            }
        },

        pageRedirect(actionItem) {
            if (actionItem === 'TOGGLE') {
                this.$root.$emit('CONTACT_TOGGLE', true);
            }

            if (actionItem === 'CLOSE_BUTTON') {
                this.$root.$emit('BACK_BUTTON', true);
            }
        },

        async updateContactInfo() {
            const url = '/app/contact';
            const message = 'Saved contact details';

            try {
                await axios.put(url, this.contactRecordDetails);
                this.$toast({ message });
                this.$root.$emit('WEATHER_UPDATE', this.contactRecordDetails);
                this.$root.$emit('UPDATE_CONTACT_STATUS', true);

                if (this.buttonActionName !== '') {
                    this.saveCustomFieldData();
                }
            } catch (error) {
                this.$error({ message: 'Something went wrong and we couldn\'t save this contacts details. Please try again.' });
            }
        },

        showConfirmModal() {
            this.$refs.confirmModal.showModal();
        },

        contactLayout() {
            this.dismissMenuGuide();

            if (this.isContactLayoutEnabled) {
                this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', true);
                this.$root.$emit('CUSTOMIZED_CONTACT_RECORD', true);
            }
        },

        async load() {
            this.getFeatureFlagValue();
            this.getNewContactRecordGuideEnabledValue();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/contact/isContactLayoutEnabled');

                this.isContactLayoutEnabled = response.data;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },

        async getNewContactRecordGuideEnabledValue() {
            try {
                const response = await axios.get('/app/contact/isNewContactRecordGuideEnabled');

                this.isNewContactRecordGuideEnabled = response.data;
            } catch (e) {
                this.$error({ message: 'Unable get new contact record guide featureFlag value' });
            }
        },

        dismissMenuIconGuide() {
            if (this.displayMenuIconGuide) {
                this.displayMenuIconGuide = false;

                updateFtuItem(this.appId, this.userId, FTU_TYPES.CONTACT_INFO_HEADER.MENU_ICON, true);
            }
        },

        dismissMenuIconButtonGuide() {
            if (this.displayMenuIconGuide) {
                this.displayMenuIconGuide = false;
                this.timeout(this.showMenuGuide());

                updateFtuItem(this.appId, this.userId, FTU_TYPES.CONTACT_INFO_HEADER.MENU_ICON, true);
            }
        },

        dismissMenuGuide() {
            if (this.displayMenuGuide) {
                this.displayMenuGuide = false;

                updateFtuItem(this.appId, this.userId, FTU_TYPES.CONTACT_INFO_HEADER.MENU, true);
            }
        },

        showMenuIconGuide() {
            if (!this.ftu[FTU_TYPES.CONTACT_INFO_HEADER.MENU_ICON]) {
                this.displayMenuIconGuide = true;
            }
        },

        showMenuGuide() {
            if (!this.ftu[FTU_TYPES.CONTACT_INFO_HEADER.MENU]) {
                this.displayMenuGuide = true;
            }
        },

        timeout(callback, timeoutMs = this.$options.GUIDE_TIMEOUT_MS) {
            setTimeout(() => {
                callback();
            }, timeoutMs);
        },
    },
};
</script>

<style lang="scss" scoped>
.controls {
    display: flex;
    justify-content: flex-end;
    margin-top: $spacing-200;

    > *:first-child {
        @include margin-end(8px);
    }
}
</style>
<style lang="scss">
.dropdown {
  .guide-body {
    word-break: break-word;
    white-space: pre-line ;
    line-height: 1.5rem;
    font-size: 1rem !important;
  }
  .top {
    width: 16rem;
  }
  .pulse-graphic {
    top: -0.8rem;
    left: -1.5rem;
  }
  .popover.open[data-v-eac614be] {
    left: -17rem !important;
  }
}

.menu-guide {
  .guide-body {
    word-break: break-word;
    white-space: pre-line ;
    line-height: 1.5rem;
    font-size: 1rem !important;
  }
  .top {
    width: 16rem;
  }
  .popover.open {
    left: -30.25rem !important;
    top: 8.5rem !important;
  }
  .pulse-graphic {
    left: -14.75rem;
    top: 9.75rem;
    z-index: 99999;
  }
}

.menu-guide-small {
  .guide-body {
    word-break: break-word;
    white-space: pre-line ;
    line-height: 1.5rem;
    font-size: 1rem !important;
  }
  .top {
    width: 16rem;
  }
  .popover.open {
    left: -30.25rem !important;
    top: 4.5rem !important;
  }
  .pulse-graphic {
    left: -14.75rem;
    top: 5.35rem;
    z-index: 99999;
  }
}
</style>
